export default "__VITE_ASSET__QV2XwOFH__"